import Skeleton from 'components/_UI/Skeleton'
import React from 'react'
import styled from 'styled-components'

export default function DashboardEventCardSkeleton() {
    return (
        <CardSkeleton>
            <Skeleton
                width="100%"
                height="160px"
                style={{ borderRadius: '12px 12px 0 0' }}
            />

            <BadgeSkeleton>
                <Skeleton
                    width="70px"
                    height="24px"
                    style={{ borderRadius: '50px' }}
                />
            </BadgeSkeleton>

            <BodySkeleton>
                <Skeleton
                    width="85%"
                    height="14px"
                    style={{ marginBottom: '8px' }}
                />
                <Skeleton
                    width="70%"
                    height="12px"
                    style={{ marginBottom: '8px' }}
                />
                <Skeleton
                    width="60%"
                    height="12px"
                />
            </BodySkeleton>
        </CardSkeleton>
    )
}

const CardSkeleton = styled.div`
    width: 100%;
    border-radius: 12px;
    background: #fff;
    position: relative;
    overflow: hidden;
`

const BadgeSkeleton = styled.div`
    position: absolute;
    top: 12px;
    left: 12px;
`

const BodySkeleton = styled.div`
    padding: 16px;
`
